import { create } from "zustand";
import { devtools } from "zustand/middleware";

type MediaStore = {
  showReSearchButton: boolean;
  mapInfo: string;
  count: number;
  searchCount: number;
  isResetMapSearchForm: boolean;
  isResearch: boolean;
  hasSearched: boolean;
  locationResetToken: number;
  setShowReSearchButton: (value: boolean) => void;
  // setMapInfo: (value: string) => void;
  resetCount: (value?: number) => void;
  setCount: (value: number) => void;
  setSearchCount: (value: number) => void;
  setResetMapSearchForm: (val: boolean) => void;
  setIsResearch: (val: boolean) => void;
  setHasSearched: (val: boolean) => void;
  resetSearchState: () => void;
  triggerLocationReset: () => void;
};

const initialState = {
  mapInfo: "@10,130,3.5z",
  showReSearchButton: false,
  count: 0,
  searchCount: 0,
  isResetMapSearchForm: false,
  isResearch: false,
  hasSearched: false,
  locationResetToken: 0,
};

export const useReSearchStore = create<MediaStore>()(
  devtools<MediaStore>(
    (set) => ({
      ...initialState,
      setShowReSearchButton: (value) => {
        set({ showReSearchButton: value });
      },
      resetCount: (value) => {
        set({ count: value ?? 1 });
      },
      setCount: (value) => {
        set({ count: value });
      },
      setSearchCount: (value) => {
        set({ searchCount: value });
      },
      setResetMapSearchForm: (val) => set({ isResetMapSearchForm: val }),
      setIsResearch: (value) => {
        set({ isResearch: value });
      },
      setHasSearched: (value) => {
        set({ hasSearched: value });
      },
      resetSearchState: () => {
        set((state) => ({
          showReSearchButton: false,
          count: 0,
          searchCount: 0,
          isResetMapSearchForm: false,
          isResearch: false,
          hasSearched: false,
          locationResetToken: state.locationResetToken + 1,
        }));
      },
      triggerLocationReset: () =>
        set((state) => ({
          locationResetToken: state.locationResetToken + 1,
        })),
    }),
    {
      name: "ResearchStore",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
